import { IAttendance } from '@modules/attendances/interfaces/IAttendance';
import { IAttendanceBody } from '@modules/attendances/services/UpdateAttendanceService';

export const formatBodyAttendance = (attendance: IAttendance[], reason?: string) => {
  let formated: IAttendanceBody = { daily_class: attendance[0].daily_class_id, attendances: [] };
  attendance.forEach((at) => formated.attendances.push({ presence: at.presence, attendance_id: at.id, retroactive_atendance_reason: reason }));
  return formated;
};
